import { OccupationCategory } from '../../../shared/models/occupation-category.model';
import { Serializable } from '../../../core/models/serializable';

export class SubscriberOccupationCategoryModel
  implements Serializable<SubscriberOccupationCategoryModel>
{
  fromObject(obj: any): SubscriberOccupationCategoryModel {
    Object.assign(this, obj);
    this.occupationCategory = null;

    if (obj.occupationCategory != null) {
      let t = new OccupationCategory();
      t = t.fromObject(obj.occupationCategory);
      this.occupationCategory = t;
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public subscriberOccupationCategoryId: number;
  public subscriberId: number;
  public occupationCategory: OccupationCategory;

  constructor() {
    this.occupationCategory = new OccupationCategory();
  }
}
